import React from "react";
import { Box, Typography } from "@mui/material";
import { BaseActionRendererProps, CoachPlanData, getActionData } from "./BaseActionRenderer";

export const CoachPlanActionRenderer: React.FC<BaseActionRendererProps> = ({ actionData }) => {
  const planData = getActionData(actionData) as CoachPlanData;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body1" sx={{ fontWeight: 500 }} gutterBottom>
        Coach Plan: {planData.title || "New Plan"}
      </Typography>

      {planData.overview && (
        <Typography variant="body2" sx={{ mb: 2, fontStyle: "italic" }}>
          {planData.overview}
        </Typography>
      )}

      {planData.goals && Object.keys(planData.goals).length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" gutterBottom sx={{ fontWeight: 500 }}>
            <b>Goals:</b>
          </Typography>
          <Box sx={{ ml: 2 }}>
            {Object.entries(planData.goals || {}).map(([key, value], index) => {
              const goalsEntries = Object.entries(planData.goals || {});
              return (
                <React.Fragment key={index}>
                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    <b>{key}:</b> {value}
                  </Typography>
                  {index < goalsEntries.length - 1 && (
                    <Typography variant="body2" color="text.secondary">
                      —
                    </Typography>
                  )}
                </React.Fragment>
              );
            })}
          </Box>
        </Box>
      )}

      {planData.actionItems && planData.actionItems.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" gutterBottom sx={{ fontWeight: 500 }}>
            <b>Action Items:</b>
          </Typography>
          <Box sx={{ ml: 2 }}>
            {planData.actionItems.map((item, index) => (
              <Typography key={index} variant="body2" sx={{ mb: 0.5 }}>
                • {item}
              </Typography>
            ))}
          </Box>
        </Box>
      )}

      {planData.trackingMetrics && planData.trackingMetrics.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" gutterBottom sx={{ fontWeight: 500 }}>
            <b>Tracking Metrics:</b>
          </Typography>
          <Box sx={{ ml: 2 }}>
            {planData.trackingMetrics.map((metric, index) => (
              <Typography key={index} variant="body2" sx={{ mb: 0.5 }}>
                • {metric}
              </Typography>
            ))}
          </Box>
        </Box>
      )}

      {actionData.reason && (
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic", mt: 1 }}>
          Reason: {actionData.reason}
        </Typography>
      )}
    </Box>
  );
};
